import React, { useState , useEffect, useContext} from 'react';


import '../css/topbar.css';
import Logo from '../images/logo.png';
import Naked from '../images/naked.png';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faInfo, faDashboard, faBookBookmark, faCalendar,
     faPuzzlePiece , faShieldAlt, faDiceOne, faBahtSign, faChartBar, faTools
    , faBell, faChevronDown, faArrowUp, faSearch} from '@fortawesome/free-solid-svg-icons';
import HomeImg from '../images/homebody.png';
import { Link, useNavigate } from 'react-router-dom'
import { ShareContext } from '../context/sharecontext';
import * as Constants from '../Constants';
import LoadingImg from '../images/loading.gif';

import IdLayout from '../components/_layout';
import IdInput from '../components/idInput';
import IdSelect from '../components/idSelect';
import JisAlert from '../components/jisalert';

function Users() {
    const { profile, token, setProfile } = useContext(ShareContext);
    const [staySigned, setStaySigned] = useState(false)
    //load profile info.
    const [agents, setAgents] =useState([]);
    const [fagents, setFAgents] =useState([]);
    const [loading, setLoading] =useState(false);
    const [agent, setAgent] = useState({id:0});
    const [view, setView] = useState('list');
    const [err, setErr] = useState('');
    const [transfer, setTransfer]=useState(0);
    const [tErr, setTErr] = useState('');
    const [searchAg, setSearchAg] =useState('');
    const [manualPay, setManualPay] = useState({});
    const [payments, setPayments] =useState([]);
    const [notifi, setNotifi] =useState({title:''});
    const [show,setShow] = useState(false);
    const [search, setSearch] = useState(null);

    const [showStatus,setShowStatus] = useState(false);
    const [applyall,setApplyAll] = useState(false);
    const [companiesList, setCompaniesList] = useState([]);
    const [roleErr, setRoleErr] = useState('');
    const [companySearch, setCompanySearch] = useState('');

    const isPlatformAdmin = profile?.userType=='Admin' || profile?.userType=='superadmin';

    const roleOptions=[{value:'Agent',text:'Agent'},{value:'Com-Owner',text:'Com-Owner'},{value:'User',text:'User (no company, platform-level)'}];

    const channels =[{value:'', text:'Select Payment Channel'},{value:'paystack', text:'Paystack'},{value:'others', text:'Other Banks'}]
    const onSave=async(e)=>{
      e.preventDefault();

        setLoading(true);

        try {
          // Admin/superadmin picks the company + role directly (can add a user, including another
          // Com-Owner, to any existing company); every other caller always gets 'Agent' under their
          // own company -- the backend enforces this regardless, this just keeps the request honest.
          var v=isPlatformAdmin ? {...agent, status:'active'} : {...agent, status:'active', userType:'Agent'};
          const resp = await fetch(`${Constants.rooturl}/customer`, {
            method: 'POST',
            body:JSON.stringify(v) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              'Authorization': token,
            },
          });

          const data = await resp.json();
          setLoading(false);
          console.log(data);
          if (data.code === 0) {
             var ag={...agent, id:data.id};
            setAgent(ag);
            var ags=[...agents];
            ags.push(ags);
            setAgents(ags);
            setView('list');
            if (data.tempPassword) {
              setNotifi({title:'User created', url:`Temporary password: ${data.tempPassword}`});
              setShow(true);
            }
            Load();
          }else {
            setErr(data.status || 'Could not save this user.');
          }
        } catch (error) {
          setLoading(false);
          setErr(Constants.serverErr);
         // onMove();
        }

       }

       const LoadCompanies=async()=>{
        try {
            const resp = await fetch(`${Constants.rooturl}/customer/companies`, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json', 'Authorization': token },
            });
            const data = await resp.json();
            if (data.code === 0) {
                // Order alphabetically by name -- the endpoint itself orders by CreateDate
                // descending (fine for companies.jsx's own management table), which isn't
                // findable once there are more than a handful of companies in a picker.
                const sorted = [...(data.coms || [])].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                setCompaniesList(sorted);
            }
          } catch (error) {
            console.error(error);
          }
       }
       const onChangeAgent=async(e)=>{
       // e.preventDefault(); 
  
          setLoading(true);
          
          try {
            var v={...agent, status:'active', userType:'Customer'};
            const resp = await fetch(`${Constants.rooturl}/customer`, {
              method: 'POST',
              body:JSON.stringify(v) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': token,
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
             alert('Changed to customer.. Continue')
             
            }else {   
              setErr('username/password not correct');
            }
          } catch (error) {
            setLoading(false);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }
    useEffect(() => {
        Load();
        if (isPlatformAdmin) {
            LoadCompanies();
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
         }, []);
    
    const Load=async()=>{
      console.log(profile);
        var urls=`${Constants.rooturl}/customer/agents`;
        try {
            setLoading(true);
            const resp = await fetch(urls, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
                'Authorization': token,
              },
            });
            
            const data = await resp.json();
          
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                
                //setProfile(data.res);
                setAgents(data.agents);
                setFAgents(data.agents);
            }else {    
                console.log(data.status);
            }
          } catch (error) {
            setLoading(false);
            console.error(error); 
          }
     }
    const onNewAgent=()=>{
        setView('agent');
        setAgent({id:0});
    }

    // Admin/superadmin only -- change an EXISTING user's role and/or the company they belong to
    // (turn a user into a Com-Owner of a company, add an existing user to a company, move an
    // agent between companies, or clear them back to a platform-level user with no company).
    const onEditRole=(a)=>{
        setRoleErr('');
        setCompanySearch('');
        setAgent({...a});
        setView('editrole');
    }

    const onSaveRole=async(e)=>{
        e.preventDefault();
        setLoading(true);
        try {
          var v={userType: agent.userType, companyId: agent.companyId?Number(agent.companyId):null};
          const resp = await fetch(`${Constants.rooturl}/customer/${agent.id}/role`, {
            method: 'PUT',
            body:JSON.stringify(v) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              'Authorization': token,
            },
          });

          const data = await resp.json();
          setLoading(false);
          console.log(data);
          if (data.code === 0) {
            setView('list');
            Load();
          }else {
            setRoleErr(data.status || 'Could not update this user.');
          }
        } catch (error) {
          setLoading(false);
          setRoleErr(Constants.serverErr);
        }
       }
    const onToggleStatus=(a)=>{
        //save the status. call it on get is fine
        setAgent(a);
        setShowStatus(true);
    }

    const onChangeStatus=async()=>{
 
      var urls=`${Constants.rooturl}/customer/changestatus/${agent.id}`;
      try {
        var v={status:agent.status=='active'?false:true, ApplyToAgents:transfer};
        const resp = await fetch(urls, {
          method: 'POST',
          body:JSON.stringify(v) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': token,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          Load();
          setApplyAll(false);
          setShowStatus(false);
        }else {   
          setErr('username/password not correct');
        }
      } catch (error) {
        setLoading(false);
        setErr(Constants.serverErr);
       // onMove();
      }
   
  } 

    const onAddUnits=(a)=>{
        setView('transfer');
        setAgent(a);
    }
    const onAddPayment=(a)=>{
      setView('payment');
      setAgent(a);
  }
    const onCancel=()=>{
        setView('list');
    }

    const onSaveTransfer=async(e)=>{
        e.preventDefault();
        try {
            var v={agentId:agent.id, units:transfer};
            const resp = await fetch(`${Constants.rooturl}/customer/transfer`, {
              method: 'POST',
              body:JSON.stringify(v) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': token,
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code == 0) {
              Load();
              setView('list');
            }else {   
              setErr('username/password not correct');
            }
          } catch (error) {
            setLoading(false);
            setErr(Constants.serverErr);
           // onMove();
          }
    }

    const onSearchAg=(value)=>{
      if(!(profile?.userType=='Admin' || profile?.userType=='Auditor')){
          if(value!=''){
          const filteredData_ = agents?.filter(item => {
            const searchMatch = item.firstName.toLowerCase().includes(value.toLowerCase()) || (item.lastName?.toLowerCase().includes(value.toLowerCase())) || item.email.toLowerCase().includes(value.toLowerCase())
            
            return searchMatch 
        })
        setFAgents(filteredData_);
        }else{
          setFAgents(agents);
        }
      }else{
        //this will search online
      }
      
      
      setSearchAg(value);
  }
  const onServerSearch=async()=>{
 
    var pp={searchdata:searchAg};
      var urls=`${Constants.rooturl}/customer/searchuser`;
      try {
          setLoading(true);
          const resp = await fetch(urls, { 
            method: 'POST',
            body:JSON.stringify(pp) ,
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token,
              
            },
          });
          
          const data = await resp.json();
        
          setLoading(false);
          console.log(data);

          if (data.code === 0) {
            setAgents(data.agents);
                setFAgents(data.agents);
          }else {    
            console.error(data.status);
          }
        } catch (error) {
          setLoading(false);
          console.error(error); 
        }
   
  }
  const onManualPayment=async(e)=>{
    try {
      e.preventDefault(); 
        var v={userid:agent.id, ...manualPay};
        const resp = await fetch(`${Constants.rooturl}/customer/manualpayment`, {
          method: 'POST',
          body:JSON.stringify(v) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': token,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          alert('Payment saved successfully')
          Load();
          setView('list');
        }else {   
          setErr(data.status);
        }
      } catch (error) {
        setLoading(false);
        setErr(Constants.serverErr);
       // onMove();
      }
}

const LoadPayment=async(a)=>{
  
  setView('listpayments');
      setAgent(a);

    var urls=`${Constants.rooturl}/customer/payments/${a.id}`;
    try {
        setLoading(true);
        const resp = await fetch(urls, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
            'Authorization': token,
          },
        });
        
        const data = await resp.json();
      
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
            
            //setProfile(data.res);
            setPayments(data.payments)
        }else {    
            console.log(data.status);
        }
      } catch (error) {
        setLoading(false);
        console.error(error); 
      }
 }

 const PasswordReset=async(a)=>{
  console.log('in password resetlink')
  
      setAgent(a);

    var urls=`${Constants.rooturl}/customer/resetlink/${a.id}`;
    try {
        setLoading(true);
        const resp = await fetch(urls, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': '',
            'Authorization': token,
          },
        });
        
        const data = await resp.json();
      
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
            
            //setProfile(data.res);
            setNotifi(data.notifiAction)
            setShow(true);
        }else {    
            console.log(data.status);
        }
      } catch (error) {
        setLoading(false);
        console.error(error); 
      }
 }

 const resetStatus=()=>{
   setApplyAll(false);
   setShowStatus(false);
 }

  const onDownloadExcel=async()=>{
        // e.preventDefault(); 
           setLoading(true);
           
           try {
             var pp={searchdata:searchAg};
            
             const resp = await fetch(`${Constants.rooturl}/customer/exportuser`, {
               method: 'POST',
               body:JSON.stringify(pp) ,
               headers: {
                 'Content-Type': 'application/json',
                 'Authorization': token,
                 'responseType': 'blob'
               },
             });
             
            const data = await resp.blob();
             setLoading(false);
             const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
             const link = document.createElement('a');
             link.download ="idverifyUsers"// 'some.pdf';
             link.href = URL.createObjectURL(blob);
             link.click();
             
 
           } catch (error) {
             setLoading(false);
             console.error(error);
             setErr(Constants.serverErr);
            // onMove();
           }
   
          }

  return (
   <IdLayout active="users" profile={profile}>
    <div>
      {loading && <div>
        <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
        </div>}  
      {view=='list' && <div>
        <button className='greenbutton no-print' onClick={onNewAgent} >{profile?.userType=='Admin'?'New User':'New Agent'} </button>
        {/* Backend (ExportUsers) already scopes a Com-Owner's export to their own CompanyId --
        this button was just never shown to them, so the only gap was here. */}
        {(profile?.userType=='Admin' || profile?.userType=='Com-Owner') && <button className='greenbutton no-print' onClick={onDownloadExcel}> Export Users</button>}
        <div >
                            {/* <FontAwesomeIcon icon={faSearch} /> */}
                           <IdInput type="text" placeholder='Search Customer/Agent Name' value={searchAg} onChange={(e) =>onSearchAg(e.target.value) }/>
{(profile?.userType=='Admin' || profile?.userType=='Auditor') && <button className='greenbutton no-print' onClick={onServerSearch} >Search</button>}
                        </div>
                        <div>
                          {notifi.title!='' &&<p>Please copy the link and send to the customer ({agent.firstName} {agent.lastName}). <strong>{notifi.url}</strong></p> }
                        </div>
            <table className='specialtable'>
            <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Balance</th>
                {profile?.userType=='Admin' && <th>User Type</th>}
                {profile?.userType=='Admin' && <th>Company</th>}
                <th>Status</th>
                <th>Date Created</th>
                <th>Actions</th>
            </tr>
        {fagents?.map((agent, idx) =>{return (
         <tr>
            <td>{agent.firstName} {agent.lastName}</td>
            <td>{agent.phone}</td>
            <td>{agent.email}</td>
            <td>{agent.unitBalance}</td>
            {profile?.userType=='Admin' && <td>{agent.userType}</td>}
            {profile?.userType=='Admin' && <td>{agent.companyName || '-'}</td>}
            <td>{agent.status}</td>
            <td>{Constants.formatDate(agent.createDate) }</td>
            <td><button onClick={()=>onToggleStatus(agent)}>{agent.status=='active'? 'Disable' :'Enable'}</button>
            <button onClick={()=>onAddUnits(agent)}>Add Unit(s)</button>
            <button onClick={()=>PasswordReset(agent)}>Reset Password</button>
           {profile?.userType=='Admin' &&
           <>
           <button onClick={()=>onAddPayment(agent)}>Add Payment</button>
           <button onClick={()=>LoadPayment(agent)}>View Payments</button>
           <button onClick={()=>onEditRole(agent)}>Edit Role/Company</button>
           {/* <button onClick={()=>LoadPayment(agent)}>Set As Customer</button> */}
           </> }
            </td>

         </tr>
        )})}
   </table>
        </div>} 
      {view=='agent' && <div>
        <div style={{display:'flex'}}>
            <div style={{textAlign:'right'}}><button onClick={()=> setView('list')}>Close</button></div>
            <div style={{width:500, maxWidth:'80%', margin:'auto'}}>
               <h1>{isPlatformAdmin ? 'New User Details' : 'New Agent Details'}</h1>
                <form  onSubmit={onSave}>
                    <div style={{display:'flex'}}>
                    <div style={{marginRight:10}}><IdInput label="First Name"
                     value={agent.firstname} onChange={(e)=>setAgent({...agent,firstname: e.target.value})} required /></div>
                    <div style={{marginLeft:10}}><IdInput label="Last Name"
                    value={agent.lastname} onChange={(e)=>setAgent({...agent,lastname: e.target.value})}  /></div>
                </div>
               <IdInput label="Email" value={agent.email}  onChange={(e)=>setAgent({...agent,email: e.target.value})} />

             {isPlatformAdmin && agent.id==0 && <div style={{display:'flex'}}>
                    <div style={{marginRight:10}}>
                        <IdSelect label="Company" disabledText="No Company (platform-level user)" value={agent.companyId||''}
                            onChange={(e)=>setAgent({...agent, companyId: e.target.value?Number(e.target.value):null})}
                            items={companiesList.map(c=>({value:c.id, text:c.name}))} />
                    </div>
                    <div style={{marginLeft:10}}>
                        <IdSelect label="Role" disabledText="Select Role" value={agent.userType||'Agent'}
                            onChange={(e)=>setAgent({...agent, userType:e.target.value})}
                            items={roleOptions} required />
                    </div>
                </div>}

             {agent.id==0 && <div style={{display:'flex'}}>
                    <div style={{marginRight:10}}> <IdInput label="Password" type="password" 
                    value={agent.password} onChange={(e)=>setAgent({...agent,password: e.target.value})}  /></div>
                   <div style={{marginRight:10}}> <IdInput label="Start Balance" type="number" 
                    value={agent.unitBalance} min={0} onChange={(e)=>setAgent({...agent,unitBalance: e.target.value})}  /></div>
                </div>}  

               {loading && <div  style={{display:'flex', justifyContent:'center', marginBottom:16, flexDirection:'column'}}>
                                  <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
                                  <span style={{ marginLeft:'auto', marginRight:'auto'}}>Loading...</span>
                                </div>}  
                    {!loading && <div style={{display:'flex', justifyContent:'center', marginBottom:16}}>
                                    <div style={{marginTop:16, marginBottom:16}}>
                                        <button className='greenbutton' style={{width:'100%'}}>Save</button>
                                        </div>          
                              </div>} 
                </form>
                
                              <div style={{fontSize:15, color:'red', textAlign:'center', padding:15, fontWeight:'bold'}}>{err}</div>
         
            </div>
       </div>
        </div>}
      {view=='editrole' && <div>
        <div style={{display:'flex'}}>
            <div style={{textAlign:'right'}}><button onClick={()=> setView('list')}>Close</button></div>
            <div style={{width:500, maxWidth:'80%', margin:'auto'}}>
               <h1>Edit Role / Company for {agent.firstName} {agent.lastName}</h1>
                <form  onSubmit={onSaveRole}>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
                    <div style={{marginRight:10}}>
                        <IdInput type='text' label='Search Company' value={companySearch} onChange={(e)=>setCompanySearch(e.target.value)} />
                    </div>
                    <div style={{marginRight:10}}>
                        {/* Only active (status 'enable') companies -- a disabled bank shouldn't be
                        a destination when reassigning a user's role/company. Alphabetically
                        sorted (see loadCompanies/LoadCompanies) and filtered by the search box above. */}
                        <IdSelect label="Company" disabledText="No Company (platform-level user)" value={agent.companyId||''}
                            onChange={(e)=>setAgent({...agent, companyId: e.target.value?Number(e.target.value):null})}
                            items={companiesList
                                .filter(c=>c.status=='enable')
                                .filter(c=>(c.name||'').toLowerCase().includes(companySearch.toLowerCase()))
                                .map(c=>({value:c.id, text:c.name}))} />
                    </div>
                    <div style={{marginLeft:10}}>
                        <IdSelect label="Role" disabledText="Select Role" value={agent.userType||''}
                            onChange={(e)=>setAgent({...agent, userType:e.target.value})}
                            items={roleOptions} required />
                    </div>
                </div>

               {loading && <div  style={{display:'flex', justifyContent:'center', marginBottom:16, flexDirection:'column'}}>
                                  <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
                                  <span style={{ marginLeft:'auto', marginRight:'auto'}}>Loading...</span>
                                </div>}
                    {!loading && <div style={{display:'flex', justifyContent:'center', marginBottom:16}}>
                                    <div style={{marginTop:16, marginBottom:16}}>
                                        <button className='greenbutton' style={{width:'100%'}}>Save</button>
                                        </div>
                              </div>}
                </form>

                              <div style={{fontSize:15, color:'red', textAlign:'center', padding:15, fontWeight:'bold'}}>{roleErr}</div>

            </div>
       </div>
        </div>}
      {view=='transfer' && <div>
        <div style={{display:'flex', backgroundColor:'white', flex:1, flexDirection:'column'}}>


         <p>  </p>
         <form onSubmit={onSaveTransfer}>
         <IdInput label="Enter Number of units to buy:" type='number' min={agent.unitBalance*-1} value={transfer} onChange={(e)=>setTransfer(e.target.value)} required/>
<div className="success-box">
         <h2>Currently {agent.firtName} {agent.lastName} has {agent.unitBalance}units. You are currently transfering {transfer}</h2>
         <p style={{color:'red'}}>Note: The negative value means deduction to your account, while + means you are adding units</p>
             <strong style={{marginTop:16, color:'red'}}>{tErr}</strong>
           <button className='greenbutton'  type='submit'>Transfer</button>  <button className='red' onClick={onCancel} type='button'>Cancel</button> 
       </div>     
         </form>  
    

    <div className='ninsearch'>
         <div className='cdiv'>
            
             <div> <span></span> <span></span> </div>
         </div>
         
    </div>
      </div>
        </div>}
        {view=='payment' && <div>
        <div style={{display:'flex', backgroundColor:'white', flex:1, flexDirection:'column'}}>


         <p>  </p>
         <form onSubmit={onManualPayment}>
          
         
          <div style={{display:'flex', flexDirection:'row'}}> 
            <IdInput label="Transaction ID" type='text' maxLength={50} value={manualPay.refid} onChange={(e)=>setManualPay({...manualPay,refid:e.target.value})} required/>
            <IdInput label="Amount Paid" type='number' min={0} value={manualPay.amount} onChange={(e)=>setManualPay({...manualPay,amount:e.target.value})} required/>
          </div>
          <div style={{display:'flex', flexDirection:'row'}}>
          <IdSelect onChange={(e)=>setManualPay({...manualPay,payChannel:e.target.value})}value={manualPay.payChannel} disabledText="Select Channel" items={channels} label='Payment Channel' required />
          <IdInput label="Transaction Date" type='date' min={0} value={manualPay.transDate} onChange={(e)=>setManualPay({...manualPay,transDate:e.target.value})} required/>  
          </div>

<div className="success-box">
         <h2>Note {agent.firtName} {agent.lastName} has {agent.unitBalance}units. </h2>
         
             <strong style={{marginTop:16, color:'red'}}>{tErr}</strong>
           <button className='greenbutton'  type='submit'>Save Payment</button>  <button className='red' onClick={onCancel} type='button'>Cancel</button> 
       </div>     
         </form>  
    

    <div className='ninsearch'>
         <div className='cdiv'>
            
             <div> <span></span> <span></span> </div>
         </div>
         
    </div>
      </div>
        </div>}
        {view=='listpayments' && <div>
          <button className='red' onClick={()=>setView('list')} type='button'>Back to List</button> 
          <table className='specialtable'> 
    <tr><th>Reference ID</th><th>Amount</th><th>Units</th><th>Date</th><th>Payment Channel</th></tr>
    {payments?.map((pay, idx) =>{return (
         <tr>
            <td>{pay.payRef}</td>
            <td>{pay.amount}</td>
            <td>{pay.balanceUnit}</td>
            <td>{Constants.formatDate(pay.createDate) } {pay.transDate!=null && <strong>**Trans Date {Constants.formatDate(pay.transDate)}</strong>} </td>
            <td>{pay.channel}</td>
         </tr>
     )})}
   </table>
   <button className='red' onClick={onCancel} type='button'>Cancel</button> 
          </div>}
    </div>
   {show && <JisAlert onOk={()=>setShow(false)} title={notifi.title} subtitle={notifi.url} />} 
   {showStatus && 
   <div className={ "dialog-box open" }>
    <div className="wrapper">
       <h3>You about to change the status of {agent.firstName} {agent.lastName} from {agent.status=='active'?'Enable':'Disable'} to {agent.status=='active'?'Disable':'Enable'}</h3>
    <div>
      <input checked={applyall} defaultChecked={applyall}  type="checkbox"  onClick={() => setApplyAll(!applyall)} />
   You want this changes for all associated agent?
    </div>
    <button onClick={()=>onChangeStatus()}>Save Changes</button>
    <button onClick={resetStatus}>Cancel</button>
    </div>
   
   
   </div>
   }  

   </IdLayout>
  )
}

export default Users